import React, { useContext, useEffect } from "react";

import { SocketContext } from "../../../common/context/quoteFormConnector";
import { LandingContext } from "../../../products/context/landing";
import { useQuoteFormState } from "../../state";
import { IQuoteFormValues } from "../../types";
import { EditForm } from "./EditForm";
import { InsurableValue } from "./InsurableValue";
import { LoadingSummary } from "./LoadingSummary";

const summaryProps = ({ attribution = { app: {} }, car, year }: IQuoteFormValues) => {
  const { app, formURL } = attribution;

  return {
    formURL,
    appName: app && app.name,
    description: "",
    title: `${car.brandName} ${car.modelName} ${car.modelYear || year}`
  };
};

const QuoteSummary: React.FC = () => {
  const { formId } = useContext(LandingContext);
  const [form] = useQuoteFormState("form");

  const { getQuoteFormById } = useContext(SocketContext);

  useEffect(() => {
    getQuoteFormById(formId!);
  }, [formId]);

  return form && form.car ? (
    <>
      <EditForm {...summaryProps(form)} />
      {form.car.valuation > 0 && <InsurableValue value={form.car.valuation} />}
    </>
  ) : (
    <LoadingSummary />
  );
};

export { QuoteSummary };
